
import { ref, computed } from "@vue/composition-api";

export function section_Layout(context) {

  const classAvatar = computed(() => "ml-n6 mt-n5 mr-3");

  const classSection = computed(() => {
    const s = "d-flex flex-column ";
    let onMobile = context.root.$vuetify.breakpoint.xsOnly;
    if (onMobile)
      return s + "mx-auto mb-3 grey lighten-2";
    else
      return s + "mx-auto mb-n2 pb-1 grey lighten-5";
  });

  const classInnerSection = computed(
    () => "mx-auto mb-1 ml-1 mr-1 grey lighten-3"
  );

  const classInnerRow = computed(
    () => "pa-0 pa-1 desktop-section-row"
  );

  const cardHeight = computed(() => {
    let onMobile = context.root.$vuetify.breakpoint.xsOnly;
    if (!onMobile) return "260";    // 200
    else return "";
  });

  // 240   :style="scrollAreaHeight"
  const scrollAreaHeight = computed(() => {
    return {
      'max-height': context.root.$vuetify.breakpoint.xsOnly ? "240px" : "",
      'flex': context.root.$vuetify.breakpoint.xsOnly ? "" : "1",
      'overflow': 'auto'
    };
  });

  return {
    classAvatar,
    classSection,
    classInnerSection,
    classInnerRow,
    scrollAreaHeight,
    cardHeight
  };

};
